<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aH8Y8w/images/cover.jpg?1684515200441" alt="This image is the cover for the book A Good Vintage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Good Vintage
      </h1>
      <p class="bookDescription body article font2">
        <p>Luke Scherer has turned bad romance into an art. When he catches his latest deadbeat boyfriend selling Luke’s belongings—and his own body—to cover his debts, Luke decides he needs a vacation. He just doesn’t expect his Napa Valley retreat to be a step into his past.</p> <p>Eight years ago Mal Kuijpers was grieving his wife while his vineyard floundered. Hiring Luke for the summer put the business back on track and a smile back on Mal’s face.</p> <p>Nineteen-year-old Luke had just gotten out from under his father’s thumb and started saving for his education, his last screw-you to his old man. Then he made the mistake of falling for his boss, his dad caught up with him, and Luke panicked—and fled.</p> <p>Now they have another chance. Mal has his own share of closet skeletons, including a family he doesn’t talk to and a dead wife he sometimes does, and he’s gone without romance for years. He works hard to convince Luke he’s worth more than a casual fling and asks for nothing in return, but Luke needs a relationship of equals. If Mal can believe in himself and Luke can believe in love, two hot summers might yield a lifelong reward.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashlyn Kane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b6323d2